/* Material */
import Button from '@mui/material/Button'
import { ButtonProps } from '@mui/material'
import useStyles from '../styles'

interface Props extends ButtonProps {
  handleAddToCart: () => void
  Status: string
  label?: string
}

const AddToCartButton: React.FC<Props> = ({ handleAddToCart, Status, label, ...buttonProps }) => {
  const classes = useStyles()

  const done = (Status === 'done')

  return <Button
    {...buttonProps}
    color={!done ? 'primary' : 'secondary'}
    size='large'
    variant='contained'
    className={classes.addToCartButton}
    fullWidth
    onClick={()=>{
      handleAddToCart()
    }} 
  >
    {!done 
      ? label || "In den Warenkorb"
      : "Zum Warenkorb hinzugefügt"
    }
  </Button>
  
}

export default AddToCartButton
